 
 
 
 
 
 
define(['../selector'], function(selector) {
    'use strict';
    var properties = [
        'address',
        'dist',
        'entryPoints',
        'position',
        'score',
        'poi',
        'type',
        'addressRanges',
        'boundingBox',
        'entityType',
        'viewport',
        'dataSources'
    ].join(', ');
    return function(json) {
        return selector(json, 'results', properties);
    };
});



// WEBPACK FOOTER //
// ./model/search/search.js